<template>
  <div>
    <el-table :data="tableData" style="width: 100%" border v-loading="loading">
      <el-table-column prop="couponName" label="优惠券名称"></el-table-column>
      <el-table-column prop="couponCode" label="优惠券编码"></el-table-column>
      <el-table-column prop="useStatus" label="使用状态">
        <template slot-scope="scope">
          {{ scope.row.useStatus | useStatusFilter(useStatusOptions) }}
        </template>
      </el-table-column>
      <el-table-column label="使用时间" prop="useTime"></el-table-column>
      <el-table-column label="订单" prop="orderNo"></el-table-column>
      <el-table-column label="优惠金额(元)" prop="couponAmount">
        <template slot-scope="scope">
          <span>¥{{ scope.row.couponAmount | 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="过期时间" prop="endTime"></el-table-column>
      <el-table-column prop="created" label="领取时间"></el-table-column>
    </el-table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    ></el-pagination>
  </div>
</template>
<script>
import { querySubscriberCouponPageApi } from "@/api/subscriber";
export default {
  name: "subscriberCoupon",
  components: {},
  props: {
    subscriberId: {
      type: String,
      default: undefined
    }
  },
  filters: {
    useStatusFilter(status, options) {
      let item = options.find(item => item.value == status);
      return item ? item.label : "未知";
    }
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
      loading: false,
      useStatusOptions: [
        { label: "未使用", value: 0 },
        { label: "已使用", value: 1 },
        { label: "已过期", value: 2 }
      ]
    };
  },
  watch: {
    subscriberId: {
      immediate: true,
      handler(val) {
        if (!val) {
          return;
        }
        this.subscriberId = val;
        this.loadPage();
      }
    }
  },
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      querySubscriberCouponPageApi(this.subscriberId, this.searchForm)
        .then(res => {
          if (res.data.status == 100) {
            this.tableData = res.data.results.list;
            this.searchForm.total = res.data.results.total;
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.loadPage();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNum = val;
      this.loadPage();
    }
  }
};
</script>



// WEBPACK FOOTER //
// subscriberCoupon.vue?c2c32306